
<template>
    
        <mars-view v-if="modalData" class="mask"><mars-view class="modal"><mars-view class="modal-title">
            {{ modalData.title }}
        </mars-view><mars-view v-for="item in modalData.sub" :key="item" class="modal-text-list">{{ item }}</mars-view><mars-view class="modal-btn"><mars-view class="modal-btn-left" @click.native.stop="cancle">返回</mars-view><mars-view class="modal-btn-right" @click.native.stop="confirm">拨打电话</mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  name: 'showModal',
  components: {},
  props: {
    modalData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    cancle() {
      this.$emit('onCancle');
    },
    confirm() {
      this.$emit('onConfirm', this.modalData);
    }
  }
};
</script>

<style scoped>
.mask {
  width: 100%;
  height: 100%;
  padding: 0 30px;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1000;
  box-sizing: border-box;
}
.mask .modal {
  width: calc(100% - 60px);
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 0.28rem;
  background: #fff;
  border-radius: 0.13rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.mask .modal-title {
  font-family: PingFangSC-Regular;
  font-size: 0.2rem;
  color: #000;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.2rem;
  font-weight: 400;
  margin-bottom: 0.32rem;
}
.mask .modal-text-list {
  width: 100%;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #999;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.25rem;
  font-weight: 400;
}
.mask .modal-btn {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  border-top: 0.66px solid #e0e0e0;
  margin-top: 0.3rem;
}
.mask .modal-btn-left {
  width: 50%;
  height: 0.48rem;
  line-height: 0.46rem;
  font-family: PingFangSC-Regular;
  font-size: 0.18rem;
  color: #000;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
.mask .modal-btn-right {
  width: 49.5%;
  height: 0.48rem;
  line-height: 0.46rem;
  font-family: PingFangSC-Regular;
  font-size: 0.18rem;
  color: #445fbb;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  box-sizing: border-box;
  border-left: 0.66px solid #e0e0e0;
}

</style>
